import { Container, LinearProgress, Grid, Skeleton } from "@mui/material";

const LoadingSkeleton = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <Container>
      <Grid container spacing={2} sx={{ my: 5 }}>
        {[...Array(6)].map((_, index) => (
          <Grid key={index} item md={2} sm={4} xs={6} py={1}>
            <Skeleton variant="rectangular" width="100%" height={250} />
            <Skeleton variant="text" width="80%" />
            <Skeleton variant="text" width="60%" />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default LoadingSkeleton;
